<nav>
  <span *ngFor="let crumb of crumbs$ | async">
    <a [routerLink]="crumb.link" [innerHTML]="crumb.label"></a>
  </span>
</nav>
<h2>{{ title$ | async }}</h2>
